<template>
  <section>
    <!-- HEADER
    ================================================== -->
    <header class="bg-secondary pt-8 pt-md-11 pb-12 mt-n6 mt-md-n10">
      <div class="container">
        <div class="row align-items-center">
          <div class="col">

            <!-- Heading -->
            <h1 class="display-3 font-weight-bold text-white mb-2">
              Terms of Use
            </h1>

            <!-- Text -->
            <p class="font-size-lg text-white-75 mb-0">
              Updated 12 December 2021
            </p>

          </div>
        </div> <!-- / .row -->
      </div> <!-- / .container -->
    </header>
    <!-- MAIN ================================================== -->
    <main class="pb-8 pb-md-11 mt-n11">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 pl-0 pr-0">
            <div class="card shadow-light-responsive mb-6">
              <div class="card-body bg-white rounded-sm-top">

                <div id="intro" class="policy-item font-size-lg">

                  <div class="policy-details">
                    <p>Welcome to Sparkello. Our core values are that everyone deserves to live a good life and
                      that the
                      preconditions for reaching our potential are knowledge, encouragement, and opportunity.
                    </p>
                    <p> Our mission is to help everyone live their best life. Our platform is designed to help
                      you, and others like you, to reach your goals by providing functionality to inspire,
                      inform, and motivate you towards your dreams. We achieve this by tapping into the power
                      of people to share their knowledge through the formation of online relationships with
                      others who have the same interests, dreams, and aspirations.
                    </p>
                    <p>In addition to the terms outlined here, it is recommended that you read our <router-link
                      to="/privacy">privacy policy</router-link>.</p>
                  </div>
                </div>


                <div id="terms" class="policy-item">
                  <div class="title">
                    <h2>1. Terms</h2>
                  </div>
                  <div class="policy-details">
                    <p>By accessing our app, Sparkello, you are agreeing to be bound by these terms of service,
                      all applicable laws and regulations, and agree that you are responsible for compliance
                      with any applicable local laws. If you do not agree with any of these terms, you are
                      prohibited from using or accessing Sparkello. The materials contained in Sparkello are
                      protected by applicable copyright and trademark law. The terms &quot;we&quot;, &quot;us&quot;
                      and &quot;our&quot; refer to Sparkello Pty Ltd.</p>
                  </div>
                </div>

                <div id="code-of-conduct" class="policy-item">
                  <div class="title"><h2>2. Code of Conduct</h2></div>
                  <div class="policy-details">
                    <p>By using Sparkello you agree to be bound by Sparkello’s code of conduct for acceptable use of the service.
                      Sparkello is an online community for goal setting and personal growth. Discussion that furthers this aim is
                      encouraged, but there are many kinds of discourse that do not belong here. This code of conduct outlines our
                      expectations for your use of the service.
                    </p>
                  </div>
                  <div class="title">
                    <h3>2.1 Acceptable conduct</h3></div>
                  <div class="policy-details">
                    <p>Acceptable and encouraged uses of Sparkello’s social networking functionality include:</p>
                    <ul>
                      <li>General posts about your thoughts and progression towards your goals</li>
                      <li>Posting about topics of interest, including relevant images, or links to external sites</li>
                      <li>Asking for help on a topic of interest</li>
                      <li>Providing advice on a topic of interest</li>
                      <li>Anything else that helps Sparkello’s user community!</li>
                    </ul>
                  </div>
                  <div class="title">
                    <h3>2.2 Prohibited content</h3></div>
                  <div class="policy-details">
                    <p>The following types of content are strictly prohibited:</p>
                    <ul>
                      <li>Sexual services</li>
                      <li>Pornography</li>
                      <li>Gambling services</li>
                      <li>Illicit drug use</li>
                      <li>Terrorism</li>
                      <li>Hate speech</li>
                      <li>Malware</li>
                      <li>Cryptocurrency and crypto mining scams</li>
                      <li>Other illegal content</li>
                    </ul>
                    <p>Users posting this kind of content will have their account and posts removed.</p>
                  </div>
                  <div class="title">
                    <h3>2.3 Abusive behaviour</h3></div>
                  <div class="policy-details">
                    <p>By using Sparkello you agree not to engage in abusive or harassing behaviour against other users. Posts and
                      comments that disregard these terms will be removed, and repeated behaviour will lead to account
                      suspension.</p>
                  </div>
                  <div class="title">
                    <h3>2.4 Product promotion</h3></div>
                  <div class="policy-details">
                    <p>Promotion of products and services is allowed but should be relevant to the interest group that it is posted
                      in. Relevant products and services should be presented in a way that describes how they are helpful to the
                      Sparkello user community. Blatant spam will be removed and may lead to suspension or removal of your
                      account.</p>
                  </div>
                  <div class="title">
                    <h3>2.5 Political content</h3></div>
                  <div class="policy-details">
                    <p>It is our desire to create a harmonious online community and for that reason political content is not allowed
                      on Sparkello. There are plenty of other places on the internet to talk about politics, but Sparkello isn’t one
                      of them. Discussion of politicians, candidates, or political parties is discouraged and will be removed.
                      However posts that intersect with border social issues are allowed and encouraged. For example a post about
                      the benefits of going vegan would be completely fine.</p>
                  </div>
                </div>

                <div id="license" class="policy-item">
                  <div class="title">
                    <h2>3. Use License</h2>
                  </div>
                  <div class="policy-details">

                    <ol type="a">
                      <li>Permission is granted to temporarily download one copy of Sparkello per device for
                        personal, non-commercial transitory viewing only. This is the grant of a license,
                        not a transfer of title, and under this license you may not:
                        <ol type="i">
                          <li>modify or copy the materials;</li>
                          <li>use the materials for any commercial purpose, or for any public display
                            (commercial or non-commercial);
                          </li>
                          <li>attempt to decompile or reverse engineer any software contained in
                            Sparkello;
                          </li>
                          <li>remove any copyright or other proprietary notations from the materials; or
                          </li>
                          <li>transfer the materials to another person or &quot;mirror&quot; the materials
                            on any other server.
                          </li>
                        </ol>
                      </li>
                      <li>This license shall automatically terminate if you violate any of these restrictions
                        and may be terminated by Sparkello Pty Ltd at any time. Upon terminating your
                        viewing of these materials or upon the termination of this license, you must destroy
                        any downloaded materials in your possession whether in electronic or printed format.
                      </li>
                    </ol>
                  </div>
                </div>

                <div id="disclaimer" class="policy-item">
                  <div class="title">
                    <h2>4. Disclaimer</h2>
                  </div>
                  <div class="policy-details">

                    <ol type="a">
                      <li>The materials within Sparkello are provided on an &quot;as is&quot; basis. Sparkello
                        Pty Ltd makes no warranties, expressed or implied, and hereby disclaims and negates
                        all other warranties including, without limitation, implied warranties or conditions
                        of merchantability, fitness for a particular purpose, or non-infringement of
                        intellectual property or other violation of rights.
                      </li>
                      <li>Further, Sparkello Pty Ltd does not warrant or make any representations concerning
                        the accuracy, likely results, or reliability of the use of the materials on its
                        website or otherwise relating to such materials or on any sites linked to Sparkello.
                      </li>
                    </ol>
                  </div>
                </div>

                <div id="limitations" class="policy-item">
                  <div class="title">
                    <h2>5. Limitations</h2>
                  </div>
                  <div class="policy-details">

                    <p>In no event shall Sparkello Pty Ltd or its suppliers be liable for any damages
                      (including, without limitation, damages for loss of data or profit, or due to business
                      interruption) arising out of the use or inability to use Sparkello, even if Sparkello
                      Pty Ltd or a Sparkello Pty Ltd authorised representative has been notified orally or in
                      writing of the possibility of such damage. Because some jurisdictions do not allow
                      limitations on implied warranties, or limitations of liability for consequential or
                      incidental damages, these limitations may not apply to you.</p>
                  </div>
                </div>

                <div id="accuracy-of-materials" class="policy-item">
                  <div class="title">
                    <h2>6. Accuracy of materials</h2>
                  </div>
                  <div class="policy-details">

                    <p>The materials appearing in Sparkello could include technical, typographical, or
                      photographic errors. Sparkello Pty Ltd does not warrant that any of the materials on
                      Sparkello are accurate, complete or current. Sparkello Pty Ltd may make changes to the
                      materials contained in Sparkello at any time without notice. However Sparkello Pty Ltd
                      does not make any commitment to update the materials.</p>

                  </div>
                </div>

                <div id="links" class="policy-item">
                  <div class="title">
                    <h2>7. Links</h2>
                  </div>
                  <div class="policy-details">
                    <p>Sparkello Pty Ltd has not reviewed all of the sites linked to its app and is not
                      responsible for the contents of any such linked site. The inclusion of any link does not
                      imply endorsement by Sparkello Pty Ltd of the site. Use of any such linked website is at
                      the user's own risk.</p>
                  </div>
                </div>

                <div id="modifications" class="policy-item">
                  <div class="title">
                    <h2>8. Modifications</h2>
                  </div>
                  <div class="policy-details">

                    <p>Sparkello Pty Ltd may revise these terms of service for its app at any time without
                      notice. By using Sparkello you are agreeing to be bound by the then current version of
                      these terms of service.</p>
                  </div>
                </div>

                <div id="governing-law" class="policy-item">
                  <div class="title">
                    <h2>9. Governing Law</h2>
                  </div>
                  <div class="policy-details">

                    <p>These terms and conditions are governed by and construed in accordance with the laws of
                      Queensland, Australia and you irrevocably submit to the exclusive jurisdiction of the
                      courts in that State or location.</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
export default {
  name: 'TermsOfService'
};
</script>

<style scoped>

</style>
